export default "__VITE_ASSET__Bg59_dnW__"